@switch (variant) {
	@case (DashboardVariant.ACTUEEL) {
		@if (row.actueelRow) {
			@let trendIcon = row.actueelRow.trendIcon;
			<div class="card-cell-single-content" [class.with-trend]="toonTrend()">
				<h2 class="card-cell-value">
					{{ row.actueelRow.or_m_nr_score > 0 && row.indicator === "op" ? "+" : "" }}{{ row.actueelRow!.or_m_nr_score | percent: "1.2-2" }}
				</h2>
				@if (toonTrend() && trendIcon) {
					<app-icon [name]="trendIcon.name" [color]="trendIcon.color" size="smallest" [rotate]="trendIcon.rotate ?? 0"></app-icon>
				}
			</div>
			<div class="card-cell-single-content">
				<span [class]="row.verschil_class">
					{{ row.or_m_nr_verschil! > 0 ? "+" : "" }}{{ row.or_m_nr_verschil! | extendedDecimal: "1.2-2" }}
				</span>
				<span class="norm">
					<span class="norm-groep">{{ row.positie_norm }}</span>
					de norm
				</span>
			</div>
		}
	}
	@case (DashboardVariant.HISTORIE) {
		@if (row.linechartProps) {
			<app-linechart [props]="row.linechartProps"></app-linechart>
		}
	}
}
